import { T } from 'react-translator-component';

interface HttpErrorLike {
  response?: { status?: number };
}

/** Criar um agendamento e editar um existente falham por motivos diferentes. */
export type ScheduleSaveContext = 'CREATE' | 'UPDATE';

/**
 * Traduz por código HTTP, nunca despejando o corpo cru da resposta na tela — o ramo de
 * envio imediato do PushNotificationConfigForm faz parsing de erro por regex sobre o
 * texto do backend (acoplamento frágil); aqui não replicamos esse padrão.
 *
 * Compartilhado entre a criação (PushNotificationConfigForm) e a edição
 * (PushScheduleEditModal): os dois falam com o mesmo endpoint de agendamento e
 * precisam reagir igual quando ele responde erro. O `context` existe porque os mesmos
 * códigos significam coisas diferentes nos dois lados: enquanto o
 * mk-ms-notification-push não estiver no ar, todo POST volta 404 — e dizer "este
 * agendamento não existe mais" para quem acabou de clicar em Agendar é mentira.
 */
export const describeSaveError = (
  error: HttpErrorLike,
  context: ScheduleSaveContext = 'UPDATE',
) => {
  const status = error?.response?.status;

  if (status === 400) {
    return T('Não foi possível salvar: verifique os campos preenchidos.');
  }

  if (context === 'CREATE') {
    if (status === 404) {
      return T('O serviço de agendamento não está disponível no momento. Avise o suporte.');
    }
    return T('Não foi possível agendar o push. Tente novamente.');
  }

  if (status === 404) {
    return T('Este agendamento não existe mais. Atualize a lista.');
  }
  if (status === 409) {
    return T('Este agendamento já foi processado e não pode mais ser editado.');
  }
  return T('Não foi possível salvar o agendamento. Tente novamente.');
};
